/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIEmployeeGroup } from './APIEmployeeGroup';
import {
    APIEmployeeGroupFromJSON,
    APIEmployeeGroupFromJSONTyped,
    APIEmployeeGroupToJSON,
} from './APIEmployeeGroup';
import type { APIEmployeeUser } from './APIEmployeeUser';
import {
    APIEmployeeUserFromJSON,
    APIEmployeeUserFromJSONTyped,
    APIEmployeeUserToJSON,
} from './APIEmployeeUser';
import type { APINamedEntity } from './APINamedEntity';
import {
    APINamedEntityFromJSON,
    APINamedEntityFromJSONTyped,
    APINamedEntityToJSON,
} from './APINamedEntity';
import type { APIWorkHour } from './APIWorkHour';
import {
    APIWorkHourFromJSON,
    APIWorkHourFromJSONTyped,
    APIWorkHourToJSON,
} from './APIWorkHour';

/**
 * 
 * @export
 * @interface APIEmployeeSearchResult
 */
export interface APIEmployeeSearchResult {
    /**
     * 
     * @type {string}
     * @memberof APIEmployeeSearchResult
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof APIEmployeeSearchResult
     */
    score: number | null;
    /**
     * 
     * @type {string}
     * @memberof APIEmployeeSearchResult
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof APIEmployeeSearchResult
     */
    data?: string;
    /**
     * 
     * @type {APIEmployeeUser}
     * @memberof APIEmployeeSearchResult
     */
    user?: APIEmployeeUser | null;
    /**
     * 
     * @type {string}
     * @memberof APIEmployeeSearchResult
     */
    userEmail?: string;
    /**
     * 
     * @type {Array<APINamedEntity>}
     * @memberof APIEmployeeSearchResult
     */
    workShifts?: Array<APINamedEntity>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIEmployeeSearchResult
     */
    workShiftNames?: Array<string>;
    /**
     * 
     * @type {Array<APIWorkHour>}
     * @memberof APIEmployeeSearchResult
     */
    workHours?: Array<APIWorkHour>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIEmployeeSearchResult
     */
    workHourWeekdays?: Array<string>;
    /**
     * 
     * @type {Array<APIEmployeeGroup>}
     * @memberof APIEmployeeSearchResult
     */
    groups?: Array<APIEmployeeGroup>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIEmployeeSearchResult
     */
    groupNames?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIEmployeeSearchResult
     */
    groupTypes?: Array<string>;
    /**
     * 
     * @type {Array<APINamedEntity>}
     * @memberof APIEmployeeSearchResult
     */
    positions?: Array<APINamedEntity>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIEmployeeSearchResult
     */
    positionNames?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof APIEmployeeSearchResult
     */
    rootAccountId?: string | null;
}

/**
 * Check if a given object implements the APIEmployeeSearchResult interface.
 */
export function instanceOfAPIEmployeeSearchResult(value: object): value is APIEmployeeSearchResult {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APIEmployeeSearchResultFromJSON(json: any): APIEmployeeSearchResult {
    return APIEmployeeSearchResultFromJSONTyped(json, false);
}

export function APIEmployeeSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIEmployeeSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'score': json['score'],
        'name': json['name'],
        'data': json['data'] == null ? undefined : json['data'],
        'user': json['user'] == null ? undefined : APIEmployeeUserFromJSON(json['user']),
        'userEmail': json['user_email'] == null ? undefined : json['user_email'],
        'workShifts': json['work_shifts'] == null ? undefined : ((json['work_shifts'] as Array<any>).map(APINamedEntityFromJSON)),
        'workShiftNames': json['work_shift_names'] == null ? undefined : json['work_shift_names'],
        'workHours': json['work_hours'] == null ? undefined : ((json['work_hours'] as Array<any>).map(APIWorkHourFromJSON)),
        'workHourWeekdays': json['work_hour_weekdays'] == null ? undefined : json['work_hour_weekdays'],
        'groups': json['groups'] == null ? undefined : ((json['groups'] as Array<any>).map(APIEmployeeGroupFromJSON)),
        'groupNames': json['group_names'] == null ? undefined : json['group_names'],
        'groupTypes': json['group_types'] == null ? undefined : json['group_types'],
        'positions': json['positions'] == null ? undefined : ((json['positions'] as Array<any>).map(APINamedEntityFromJSON)),
        'positionNames': json['position_names'] == null ? undefined : json['position_names'],
        'rootAccountId': json['root_account_id'] == null ? undefined : json['root_account_id'],
    };
}

export function APIEmployeeSearchResultToJSON(value?: APIEmployeeSearchResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'score': value['score'],
        'name': value['name'],
        'data': value['data'],
        'user': APIEmployeeUserToJSON(value['user']),
        'user_email': value['userEmail'],
        'work_shifts': value['workShifts'] == null ? undefined : ((value['workShifts'] as Array<any>).map(APINamedEntityToJSON)),
        'work_shift_names': value['workShiftNames'],
        'work_hours': value['workHours'] == null ? undefined : ((value['workHours'] as Array<any>).map(APIWorkHourToJSON)),
        'work_hour_weekdays': value['workHourWeekdays'],
        'groups': value['groups'] == null ? undefined : ((value['groups'] as Array<any>).map(APIEmployeeGroupToJSON)),
        'group_names': value['groupNames'],
        'group_types': value['groupTypes'],
        'positions': value['positions'] == null ? undefined : ((value['positions'] as Array<any>).map(APINamedEntityToJSON)),
        'position_names': value['positionNames'],
        'root_account_id': value['rootAccountId'],
    };
}

